export enum SearchEvent
{
    Customer,
    OrderNo,
    AppointmentDates,
    Team,
    AppointmentType
}